<template>
    <div class="display-flex-center">
        <div v-if="!isMobile">
            <div
                class="pointer display-flex lang-icon"
                @click="handleShowSettingList('click')"
                v-if="isLogin"
            >
                <SvgIcon icon="c.header.setting.iconLanguage"> </SvgIcon>
            </div>
        </div>
        <div class="relative" v-if="isLogin">
            <!-- setting selection -->
            <!-- <div class="setting-list__wrapper" :class="{ selected: isShowSettingList }">
        <div
          class="setting-list__container"
          v-for="(o, index) in settingList"
          :key="index"
          @click="handleSetting(o)"
        >
          <div class="setting-list__name">
            <span>{{ $t(o.name) }}</span>
          </div>
          <div v-if="o.hasChild">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10.776 8L4 1.224L5.224 0L12 8L5.224 16L4 14.776L10.776 8Z" fill="#242527"/>
            </svg>
          </div>
        </div>
      </div> -->

            <!-- country selection -->
            <!-- <transition name="slide">
        <div class="setting-list__wrapper selected" v-if="isShowCountryList">
          <div class="setting-list__container">
            <div class="setting-list__name" @click="handleCountryBack()">
              <div class="setting-list__name-icon flex-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M5.224 8L12 14.776L10.776 16L4 8L10.776 0L12 1.224L5.224 8Z" fill="#242527"/>
                </svg>
              </div>
              <span>{{ $t("SELECT_COUNTRY") }}</span>
            </div>
          </div>

          <div
            class="setting-list__container"
            v-for="(o, index) in countryList"
            :key="index"
            :class="{ selected: o.selected }"
            @click="countrySelectItem(o)"
          >
            <div class="setting-list__name">
              <div class="setting-list__name-icon">
                <img
                  class="img-contain flag-icon "
                  :src="require(`../../../static/images/flags/${o.icon}.png`)"
                />
              </div>
              <span>{{ o.name }}</span>
            </div>
            <div v-if="o.selected">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6.0002 12.3137L2.35355 8.66706L1.64645 9.37416L6.0002 13.7279L14.3536 5.37456L13.6464 4.66746L6.0002 12.3137Z" fill="#242527"/>
              </svg>
            </div>
          </div>
        </div>
      </transition> -->

            <!--currentLanguageList-->
            <!-- langauge selection -->
            <!-- <transition name="slide">
        <div class="setting-list__wrapper selected" v-if="isShowLanguageList">
          <div class="setting-list__container">
            <div class="setting-list__name" @click="handleLanguageBack()">
              <div class="setting-list__name-icon flex-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M5.224 8L12 14.776L10.776 16L4 8L10.776 0L12 1.224L5.224 8Z" fill="#242527"/>
                </svg>
              </div>
              <span>{{ $t("LANGUAGE") }}</span>
            </div>
          </div>

          <div
            class="setting-list__container"
            v-for="(o, index) in userLangList"
            :key="index"
            :class="{ selected: o.selected }"
            @click="languageSelectItem(o)"
          >
            <div class="setting-list__name">
              <span>{{ o.displayName }}</span>
            </div>
            <div v-if="o.selected">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6.0002 12.3137L2.35355 8.66706L1.64645 9.37416L6.0002 13.7279L14.3536 5.37456L13.6464 4.66746L6.0002 12.3137Z" fill="#242527"/>
              </svg>
            </div>
          </div>
        </div>
      </transition> -->
        </div>

        <div class="header-profile-pic hidden" v-if="!isMobile">
            <div class="avatar-icon" @click="handleShowSidePopupSettingList()">
                <!-- menu icon -->
                <SvgIcon
                    icon="c.header.setting.iconMenu"
                    className="avatar-icon-menu"
                >
                </SvgIcon>

                <Avatar width="32px" height="32px" v-if="isLogin" />

                <template v-else>
                    <IconMode>
                        <template #default="{ index }">
                            <img
                                src="@static/images/icons/aspn_icon/icon_avatar.png"
                                v-if="
                                    ['lightWeb', 'lightWebapp'].includes(index)
                                "
                                class="avatar-icon-img"
                            />
                            <img
                                src="@static/images/icons/aspn_icon/icon_avatar_dark.png"
                                v-else-if="
                                    ['darkWeb', 'darkWebapp'].includes(index)
                                "
                                class="avatar-icon-img"
                            />
                        </template>
                    </IconMode>
                </template>
            </div>
        </div>
    </div>

    <!-- web account -->
    <AccountWebPopup ref="accountWebPopupRef" />

    <!-- language list -->
    <Popup
        v-model:show="isShowLanguageList"
        type="center"
        className="popup-country"
    >
        <div>
            <!-- {{ isShowLanguageList }} -->
            <div style="height: 100%">
                <div class="language-box">
                    <div class="language-title">
                        {{ $t("SUGGESSTION_COUNTRY_AND_LANGUAGE") }}
                    </div>
                    <div class="language-list">
                        <template v-for="(item, index) in countryList">
                            <template
                                v-if="
                                    item.countryCode === suggesstionCountryCode
                                "
                            >
                                <div
                                    class="language-item"
                                    v-for="(sec, index2) in item.countryLang"
                                    :key="index"
                                    :class="[
                                        {
                                            selected: sec.selected2,
                                        },
                                    ]"
                                    @click="selectLang(countryList, item, sec)"
                                >
                                    <img
                                        class="img-contain flag-icon mr-05rem"
                                        :src="
                                            require(`../../../static/images/flags/${item.icon}.png`)
                                        "
                                    />
                                    <div>
                                        <div class="language-country">
                                            {{ item.name }}
                                        </div>
                                        <div class="language-country-name">
                                            {{ sec.displayName }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>

                <div class="language-box">
                    <div class="language-title">
                        {{ $t("OTHER_COUNTRY_AND_LANGUAGE") }}
                    </div>
                    <div class="language-list">
                        <template v-for="(item, index) in countryList">
                            <template
                                v-if="
                                    item.countryCode !== suggesstionCountryCode
                                "
                            >
                                <div
                                    class="language-item"
                                    v-for="(sec, index2) in item.countryLang"
                                    :key="index"
                                    :class="[
                                        {
                                            selected: sec.selected2,
                                        },
                                    ]"
                                    @click="selectLang(countryList, item, sec)"
                                >
                                    <SvgIconCountry
                                        :icon="item.name"
                                    ></SvgIconCountry>
                                    <img
                                        class="img-contain flag-icon mr-05rem"
                                        :src="
                                            require(`../../../static/images/flags/${item.icon}.png`)
                                        "
                                    />
                                    <div>
                                        <div class="language-country">
                                            {{ item.name }}
                                        </div>
                                        <div class="language-country-name">
                                            {{ sec.displayName }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>

            <!-- <pre>
            {{ countryList }}
        </pre> -->
        </div>
    </Popup>
</template>

<script>
import config from "@/js/config.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import HeaderAppBanner from "../modal/HeaderAppBanner.vue";
import AccountWebPopup from "../account/AccountWebPopup.vue";
import Avatar from "@/components/account/Avatar.vue";

export default {
    data() {
        return {
            settingList: [
                // {
                //   name: "PROFILE_SETTING",
                //   id: "profileSetting",
                //   hasChild: false,
                // },
                {
                    name: "COUNTRY",
                    id: "country",
                    hasChild: true,
                },
                {
                    name: "LANGUAGE",
                    id: "language",
                    hasChild: true,
                },
                // {
                //   name: "LOG_OUT",
                //   id: "logout",
                //   hasChild: false,
                // },
            ],
            s3ImgUrl: config.s3ImgUrl,
            fantasySportLogoutUrl: config.fantasySportLogoutUrl,
            isShowSettingList: false,
            isShowCountryList: false,
            isShowLanguageList: false,
            redirectShow: false,

            userLangList: [],
            countryList: [],
            suggesstionCountryList: config.supportedCountryList,
            apiCallDone: true,

            suggesstionCountryCode: "SG",
            isShowLanguageList: false,
            countrySelected: "",
            langSelected: "",
        };
    },
    components: {
        HeaderAppBanner,
        AccountWebPopup,
        Avatar,
    },
    props: {
        isLoginPage: Boolean,
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "isLogin",
            "userInfo",
            "currentLocale",
            "currentLanguageList",
            "currentCountryList",
            // "userLangConfig",
            "userSelectedLangConfigObj",
            "currentCountryObj",
            "currentLanguageObj",
        ]),
    },
    watch: {
        isLogin: {
            handler(newVal, oldval) {
                this.init();
            },
        },
    },
    mounted() {
        this.init();
        this.initCountryAndLanguageList();
    },
    methods: {
        ...mapMutations([
            "USER_SWITCH_COUNTRY_LANG",
            "COUNTRY_CODE_TO_LANG_OBJ_LIST",
            "UPDATE_USER_LANG_CONFIG",
            "REMOVE_USER_LANG_CONFIG",
        ]),
        ...mapActions([
            "postLogout",
            "logoutEvent",
            "currentLocaleChangeEvent",
            "postUpdateProfilePreferredLanguage",
            "getRetrieveUserInfo",
            "setUserData",
            "toastrChangeEvent",
            "currentCountryChangeEvent",
            "postUpdateProfilePreferredCountry",
            "getCountryCodeByIp",
            "commonVerifyLogin",
            "currentCountryLocaleChangeEvent",
            "toggleCountryAndLanguage",
        ]),

        init() {
            this.commonVerifyLogin();
            // this.countryList = this.currentCountryList;
            if (this.isLogin) {
                // this.initCountryList();
                this.setLangList(this.userInfo.preferredCountry);
            }
        },
        initCountryAndLanguageList() {
            if (!this.isLogin) {
                return;
            }
            const countryList = this.currentCountryList;
            countryList.forEach((x) => {
                x.selected =
                    x.countryCode === this.userInfo.preferredCountry
                        ? true
                        : false;
            });

            const langList = this.currentLanguageList;
            let currentCountryCode = this.currentCountryObj.countryCode;
            let currentLocale = this.currentLocale;

            for (var i1 in countryList) {
                let countryCode = countryList[i1].countryCode;
                let supportedList = countryList[i1].supportedLocale;

                let countryLang = [];
                for (var i2 in langList) {
                    let langItem = JSON.parse(JSON.stringify(langList[i2]));
                    let locale = langItem.locale;
                    if (
                        countryCode === currentCountryCode &&
                        locale === currentLocale
                    ) {
                        langItem.selected2 = true;
                        this.countrySelected = countryList[i1];
                        this.langSelected = langItem;
                    } else {
                        langItem.selected2 = false;
                    }
                    if (supportedList.includes(locale)) {
                        countryLang.push(langItem);
                    }
                }
                countryList[i1]["countryLang"] = countryLang;
            }
            // this.countryList = countryList
            this.countryList = countryList;
        },
        // initCountryList() {
        //   this.countryList = this.currentCountryList;
        //   this.countryList.forEach(x => {
        //     x.selected = (x.countryCode === this.userInfo.preferredCountry) ? true : false;
        //   });
        // },

        setCountryList(o) {
            this.countryList = this.currentCountryList;
            this.countryList.forEach((x) => {
                x.selected = x.countryCode === o.countryCode ? true : false;
            });
        },

        async setLangList(countryCode) {
            let supportedLocaleList = this.currentCountryList.filter(
                (x) => x.countryCode === countryCode
            )[0].supportedLocale;
            this.userLangList = [];

            if (!this.isLogin) {
                let result = await this.getCountryCodeByIp();
                if (result.message === "Success") {
                    this.currentCountryChangeEvent(result.result.countryCode);
                }
            }

            supportedLocaleList.forEach((locale) => {
                this.currentLanguageList.forEach((obj) => {
                    if (obj.displayLocale === locale) {
                        obj.selected =
                            obj.displayLocale === this.currentLocale
                                ? true
                                : false;
                        this.userLangList.push(obj);
                    }
                });
            });
        },

        handleShowSettingList(action) {
            this.isShowLanguageList = !this.isShowLanguageList;
            return;
            if (this.isMobile) {
                this.$router.push({ name: "account" });
            } else {
                if (action === "enter" && !this.isMobile) {
                    //ingnore mobile touch event
                    this.isShowSettingList = true;
                } else if (action === "click") {
                    if (this.isShowLanguageList || this.isShowCountryList) {
                        this.isShowSettingList = false;
                        this.isShowCountryList = false;
                        this.isShowLanguageList = false;
                    } else {
                        this.isShowSettingList = !this.isShowSettingList;
                        this.isShowCountryList = false;
                        this.isShowLanguageList = false;
                    }
                } else {
                    this.isShowSettingList = false;
                    this.isShowCountryList = false;
                    this.isShowLanguageList = false;
                }
            }
        },
        handleSetting(o) {
            switch (o.id) {
                case "profileSetting":
                    this.handleProfileSetting();
                    this.isShowSettingList = false;
                    break;
                case "country":
                    this.handleCountrySelect();
                    this.isShowCountryList = true;
                    break;
                case "language":
                    this.handleLanguageSelect();
                    break;
                case "logout":
                    this.handleLogout();
                    this.isShowSettingList = false;
                    break;
            }
        },
        handleCountrySelect() {
            this.isShowSettingList = false;
            this.isShowCountryList = true;
        },
        handleLanguageSelect() {
            this.isShowSettingList = false;
            this.isShowLanguageList = true;
        },
        //handle logout
        async handleLogout() {
            let deviceTokenMotification = localStorage.getItem(
                "deviceTokenNotification"
            );
            let params = {
                token: this.userInfo.token,
            };
            if (deviceTokenMotification) {
                params.deviceToken = deviceTokenMotification;
            }

            const result = await this.postLogout(params);

            if (this.$route.meta.parent === "account") {
                this.$router.push(`/${this.currentLocale}`);
            }

            this.logoutEvent();

            //logout fantasy
            let fantasyHtml = $(
                `<iframe class="fantasy-iframe-logout" onload="$('.fantasy-iframe-logout').remove()" src="${this.fantasySportLogoutUrl}?logout=true"></iframe>`
            );
            $("body").append(fantasyHtml);

            this.REMOVE_USER_LANG_CONFIG();
        },
        //handle profile setting
        handleProfileSetting() {
            this.$router.push({ name: "myProfile" });
        },
        handleCountryBack() {
            this.isShowSettingList = true;
            this.isShowCountryList = false;
        },
        handleLanguageBack() {
            this.isShowSettingList = true;
            this.isShowLanguageList = false;
        },
        // get user info
        async getRetrieveUserInfoData() {
            let params = {
                token: this.userInfo.token,
                timeZone: this.$tools.getCurrentTimeZone(),
            };

            const result = await this.getRetrieveUserInfo(params);
            this.setUserData(result.result.data);
        },

        async countrySelectItem(o) {
            if (this.isLogin && this.apiCallDone) {
                this.apiCallDone = false;
                // this.currentCountryChangeEvent(o.countryCode);
                this.setCountryList(o);
                this.setLangList(o.countryCode);
                this.userLangList.forEach((lang, i) => {
                    lang.selected = i === 0 ? true : false;
                });
                let defaultCountryLangObj = this.userLangList[0];

                let params = {
                    preferredCountry: o.countryCode,
                };

                const result = await this.postUpdateProfilePreferredCountry(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredCountry = o.countryCode;
                    this.setUserData(localStorageUser);
                    this.languageSelectItem(
                        defaultCountryLangObj,
                        o.countryCode
                    );
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);
                }
            }
        },

        async languageSelectItem(o, countryCode = null) {
            if (this.apiCallDone) {
                this.apiCallDone = false;
                let theCountryCode =
                    countryCode === null
                        ? this.userInfo.preferredCountry
                        : countryCode;

                let params = {
                    preferredLanguage: o.locale,
                    token: this.userInfo.token,
                };
                const result = await this.postUpdateProfilePreferredLanguage(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredLanguage = o.locale;
                    this.setUserData(localStorageUser);
                    this.currentCountryLocaleChangeEvent({
                        countryCode: theCountryCode,
                        locale: o.locale,
                    });

                    this.USER_SWITCH_COUNTRY_LANG();

                    //this.currentLocaleChangeEvent(o.displayLocale);//currentLanguageObj
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);

                    // this.$root.toastrMsg = result.result.message;
                    // this.$root.$refs.toastrRef.handleOpen();
                }

                this.toggleCountryAndLanguage();
                this.UPDATE_USER_LANG_CONFIG(o.displayLocale);
            }
        },

        handleShowSidePopupSettingList() {
            this.$refs.accountWebPopupRef.handleShowSidePopupSettingList();
        },
        selectLang(countryList, item, sec) {
            for (var i1 in countryList) {
                for (var i2 in countryList[i1].countryLang) {
                    countryList[i1].countryLang[i2].selected2 = false;
                }
            }

            sec.selected2 = true;
            this.countrySelected = item;
            this.langSelected = sec;
            this.handleDone();
        },
        handleDone() {
            this.countrySelectItem();
        },
        async countrySelectItem() {
            if (this.isLogin && this.apiCallDone) {
                this.apiCallDone = false;

                let params = {
                    // preferredCountry: o.countryCode,
                    preferredCountry: this.countrySelected.countryCode,
                };

                const result = await this.postUpdateProfilePreferredCountry(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredCountry =
                        this.countrySelected.countryCode;
                    this.setUserData(localStorageUser);
                    this.languageSelectItem(
                        this.langSelected,
                        this.countrySelected.countryCode
                    );
                    localStorage.setItem(
                        "newsLang",
                        JSON.stringify(this.langSelected)
                    );
                    localStorage.setItem("language", this.langSelected.locale);
                    this.$emit("updateWebNewsLang", this.langSelected);
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);
                }
            }
        },

        async languageSelectItem(o, countryCode = null) {
            if (this.apiCallDone) {
                this.apiCallDone = false;
                let theCountryCode =
                    countryCode === null
                        ? this.userInfo.preferredCountry
                        : countryCode;

                let params = {
                    preferredLanguage: o.locale,
                    token: this.userInfo.token,
                };
                const result = await this.postUpdateProfilePreferredLanguage(
                    params
                );
                this.apiCallDone = true;

                if (result.result.businessCode === 0) {
                    // this.getRetrieveUserInfoData();
                    let localStorageUser = JSON.parse(
                        localStorage.getItem("user")
                    );
                    localStorageUser.preferredLanguage = o.locale;
                    this.setUserData(localStorageUser);
                    this.currentCountryLocaleChangeEvent({
                        countryCode: theCountryCode,
                        locale: o.locale,
                    });

                    this.USER_SWITCH_COUNTRY_LANG();
                    //this.currentLocaleChangeEvent(o.displayLocale);//currentLanguageObj
                } else {
                    let params = {
                        isOpen: true,
                        msg: result.result.message,
                        type: "info",
                    };
                    this.toastrChangeEvent(params);
                    // this.$root.toastrMsg = result.result.message;
                    // this.$root.$refs.toastrRef.handleOpen();
                }

                this.toggleCountryAndLanguage();
                this.UPDATE_USER_LANG_CONFIG(o.displayLocale);
                this.isShowLanguageList = false;
            }
        },
    },
};
</script>

<style scoped>
.country-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-border-default-default);
    padding: 21px 16px;
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
}
.done-text {
    color: var(--color-text-primary-default);
}
.language-list {
    display: grid;
    grid-template-columns: auto auto auto auto;
    box-sizing: border-box;
}
.language-item {
    padding: 16px;
    color: var(--color-text-default-default);
    display: flex;
    border-radius: 8px;
    align-items: center;
    cursor: pointer;
}
.language-item .flag-icon {
    width: 40px;
    height: 40px;
    max-width: unset;
}
.language-item.selected {
    background-color: var(--color-background-neutral-default);
    background-image: url("../../../static/images/icons/aspn_icon/language/language_hover.png");
    background-size: 80%;
    background-position: 76px -20px;
    background-repeat: no-repeat;
}
.country-item {
    padding: 8px 16px;
    color: var(--color-text-default-secondary);
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 8px;
}
.country-lang-item {
    /* padding: 0 16px; */
    font-family: var(--weight-700);
    margin-bottom: 8px;
    font-size: 14px;
}
.language-country {
    color: var(--color-text-default-secondary);
    letter-spacing: 0.64px;
    font-size: 14px;
}
.language-country-name {
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
    font-family: var(--weight-600);
    font-weight: bold;
}
.language-item.selected .language-country {
    color: var(--color-text-default-tertiary);
}
.language-item.selected .language-country-name {
    color: var(--color-text-default-neutral);
}
.language-box {
    padding: 24px;
}
.language-title {
    color: var(--color-text-default-default);
    font-size: 24px;
    margin-bottom: 24px;
    font-family: var(--weight-600);
    letter-spacing: -0.64px;
}
.lang-icon {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: var(--color-background-default-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.lang-icon:hover {
    background-color: var(--color-background-default-secondary-hover);
}
</style>

<style>
.flag-icon {
    width: 22px;
    height: 22px;
}
.setting-list__wrapper {
    position: absolute;
    right: 0;
    margin-top: 1rem;
    min-width: 12rem;
    background-color: var(--color-background-default-secondary);
    padding: 0.5rem 0;
    border-radius: 0.5rem;
    transform: scale(0);
    transform-origin: 11.5rem 0%;
    transition: all 0.3s;
    border: 1px solid var(--color-background-default-default);
    z-index: 5;
}
.setting-list__wrapper.selected {
    /* transform-origin: 11.5rem 0%; */
    /* transform: scale(1); */
}
.setting-list__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.3rem 0.5rem;
    cursor: pointer;
    transition: all 0.3s;
}
.setting-list__container.selected,
.setting-list__container:hover {
    background-color: var(--color-background-brand-default) !important;
}
.setting-list__name {
    display: flex;
    align-items: center;
    font-size: 0.88rem;
    color: var(--color-text-default-default);
}
.setting-list__container.selected .setting-list__name,
.setting-list__container:hover .setting-list__name {
    color: var(--color-button-active);
}
.setting-list__container.selected path,
.setting-list__container:hover path {
    fill: var(--color-button-active);
}

.setting-list__name-icon {
    object-fit: contain;
    margin-right: 0.7rem;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style>
@media (min-width: 768px){
    .popup-country {
        height: 754px !important;
        width: 956px !important;
        border-radius: 8px 8px 0 0;
    }
}
</style>
